// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DiscoverDuePaymentsQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query input for GET /payroll/discover_due_payments
 *
 * `franchise_id` is required by the controller (validated after binding, same
 * message as the other payroll GETs). `frequency` narrows to one bucket
 * (weekly | biweekly | monthly); absent = all three.
 */
import { registerContract } from './validate'

export interface Payroll_DiscoverDuePaymentsQueryInput {
franchise_id?: number
frequency?: string
}

registerContract('Payroll_DiscoverDuePaymentsQueryInput', {
  franchise_id: { type: 'number',  required: false },
  frequency:    { type: 'string',  required: false },
})
